<!-- バックヤード > ニュース追加 -->
<template>
  <div>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <news-form />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import NewsForm from './_Form'

export default {
  components: {
    NewsForm,
  },
  mixins: [
  ],
  data () {
    return {
      news: {},
      breadcrumbs: [
        { text: 'ニュース一覧', disabled: false, to: '/backyard/news', exact: true },
        { text: 'ニュース詳細', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {
  },
}
</script>

<style lang="scss">

</style>
